<template>
  <div class="layout-container">
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="200px" class="sidebar">
        <div class="logo-container">
          <h2>中科沛力</h2>
        </div>
        
        <el-menu
          :default-active="activeMenu"
          class="sidebar-menu"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          router
        >
          <el-menu-item index="/dashboard">
            <el-icon><House /></el-icon>
            <span>首页</span>
          </el-menu-item>
          
          <el-sub-menu index="products">
            <template #title>
              <el-icon><Goods /></el-icon>
              <span>商品管理</span>
            </template>
            <el-menu-item index="/products">
              <el-icon><List /></el-icon>
              <span>商品列表</span>
            </el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu index="users">
            <template #title>
              <el-icon><User /></el-icon>
              <span>用户管理</span>
            </template>
            <el-menu-item index="/users">
              <el-icon><List /></el-icon>
              <span>用户列表</span>
            </el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu index="content">
            <template #title>
              <el-icon><Document /></el-icon>
              <span>文章</span>
            </template>
            <el-menu-item index="/content/articles">
              <el-icon><Document /></el-icon>
              <span>文章管理</span>
            </el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu index="review">
            <template #title>
              <el-icon><DocumentChecked /></el-icon>
              <span>审核中心</span>
            </template>
            <el-menu-item index="/review-center">
              <el-icon><Picture /></el-icon>
              <span>头像审核</span>
            </el-menu-item>
            <el-menu-item index="/member-review">
              <el-icon><UserFilled /></el-icon>
              <span>会员审核</span>
            </el-menu-item>
            <el-menu-item index="/article-review">
              <el-icon><DocumentChecked /></el-icon>
              <span>文章审核</span>
            </el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu index="distribution">
            <template #title>
              <el-icon><Share /></el-icon>
              <span>分销管理</span>
            </template>
            <el-menu-item index="/distribution-center">
              <el-icon><Connection /></el-icon>
              <span>分销中心</span>
            </el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu index="orders">
            <template #title>
              <el-icon><List /></el-icon>
              <span>订单管理</span>
            </template>
            <el-menu-item index="/orders-to-deliver">
              <el-icon><List /></el-icon>
              <span>待发货订单</span>
            </el-menu-item>
            <el-menu-item index="/orders-delivered">
              <el-icon><List /></el-icon>
              <span>已发货订单</span>
            </el-menu-item>
            <el-menu-item index="/orders-completed">
              <el-icon><List /></el-icon>
              <span>快递完成订单</span>
            </el-menu-item>
            <el-menu-item index="/pickup-locations">
              <el-icon><Location /></el-icon>
              <span>自提地址管理</span>
            </el-menu-item>
            <el-menu-item index="/pickup-orders">
              <el-icon><Box /></el-icon>
              <span>自提订单</span>
            </el-menu-item>
            <el-menu-item index="/pickup-orders-completed">
              <el-icon><Box /></el-icon>
              <span>自提完成</span>
            </el-menu-item>
            <el-menu-item index="/product-review-center">
              <el-icon><List /></el-icon>
              <span>评价中心</span>
            </el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu index="message">
            <template #title>
              <el-icon><Message /></el-icon>
              <span>消息管理</span>
            </template>
            <el-menu-item index="/message-center">
              <el-icon><Bell /></el-icon>
              <span>消息中心</span>
            </el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>
      
      <!-- 主内容区 -->
      <el-container>
        <!-- 顶部导航栏 -->
        <el-header class="header">
          <div class="header-left">
            <el-button type="text" @click="toggleSidebar">
              <el-icon><Fold v-if="!isCollapse" /><Expand v-else /></el-icon>
            </el-button>
          </div>
          
          <div class="header-right">
            <el-dropdown @command="handleCommand">
              <span class="user-dropdown">
                {{ currentUser?.name || '管理员' }}
                <el-icon class="el-icon--right"><arrow-down /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="profile">个人中心</el-dropdown-item>
                  <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>
        
        <!-- 主要内容区域 -->
        <el-main class="main-content">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'

export default {
  name: 'Layout',
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const isCollapse = ref(false)
    
    const currentUser = computed(() => store.getters.currentUser)
    const activeMenu = computed(() => route.path)
    
    const toggleSidebar = () => {
      isCollapse.value = !isCollapse.value
    }
    
    const handleCommand = (command) => {
      if (command === 'logout') {
        ElMessageBox.confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('logout')
          ElMessage.success('已退出登录')
          router.push('/login')
        }).catch(() => {})
      } else if (command === 'profile') {
        ElMessage.info('个人中心功能开发中')
      }
    }
    
    return {
      isCollapse,
      currentUser,
      activeMenu,
      toggleSidebar,
      handleCommand
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.sidebar {
  background-color: #304156;
  transition: width 0.3s;
}

.logo-container {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2b2f3a;
  color: #fff;
}

.logo-container h2 {
  margin: 0;
  font-size: 18px;
}

.sidebar-menu {
  border-right: none;
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.header {
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.user-dropdown {
  cursor: pointer;
  color: #606266;
  display: flex;
  align-items: center;
}

.main-content {
  background-color: #f0f2f5;
  padding: 20px;
}
</style>
